import { Lang } from '../../../../../../types/global';

export interface BaseBuilderOptions {
  cate_root_id: number;
  lang?: Lang['lang'];
}

export interface IBuilder {
  /**
   * URL 생성
   */
  build(): string;

  /**
   * 빌더 복사
   */
  clone(): IBuilder;
}

/**
 * 베이스 빌더 클래스
 */
export class BaseBuilder {
  protected options: BaseBuilderOptions;

  constructor(initialOptions: BaseBuilderOptions) {
    this.options = { ...initialOptions };
  }

  /**
   * 언어 설정
   */
  setLang(lang: Lang['lang']): this {
    this.options.lang = lang;
    return this;
  }

  getLangOrThrow(): Lang['lang'] {
    const lang = this.options.lang;

    if (!lang) {
      throw new Error('언어(lang)는 필수입니다.');
    }

    return lang;
  }

  // TODO: 나중에 VO 로 교체
  getCateRoot(): { id: number } {
    return {
      id: this.options.cate_root_id,
    };
  }
}
